// extracted by mini-css-extract-plugin
export default {"tags":"TagList_tags__jRLiY","tag_item":"TagList_tag_item__c4YwR"};